import { useEffect } from 'react';
import { useTranslation } from "react-i18next";
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { CustomLoader } from '../../components';

const ConfirmEmail = () => {
  const { t } = useTranslation();
  const { token } = useParams();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(window.location.search);
  const uid = searchParams.get("uid");

  useEffect(() => {
    const confirmEmail = async () => {
      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}/auth/confirm-email/${token}/?uid=${uid}`,
          {},
          { headers: { "Content-Type": "application/json" } }
        );

        if (response.status === 202) {
          const { has_password } = response.data;
          toast.success(t("email-verification-successfull", "Votre email a bien été validé !"));

          if (has_password) {
            navigate("/login");
          } else {
            navigate(`/create-password?uid=${encodeURIComponent(uid)}`);
          }
        }
      } catch (error) {
        const status = error?.response?.status;

        if (status === 409) {
          toast.info(t("user-already-verified", "Ce compte est déjà vérifié."));
          navigate("/login");
        } else if (status === 406 && uid) {
          navigate(`/expired-link?uid=${uid}`);
        } else {
          toast.error(t("something-went-wrong", "Une erreur s'est produite"));
        }
      }
    };

    confirmEmail();
  }, [token, navigate, t, uid]);

  return <CustomLoader />;
};

export default ConfirmEmail;